import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/rolesConstants';

const initialState = {
  roles: [],
  loading: true,
};

const rolesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_ROLES:
      return {
        ...initialState,
      };
    case types.GET_ROLES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_ROLES_SUCCESS:
      return {
        ...state,
        roles: payload,
        loading: false,
      };
    case types.GET_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default rolesReducer;
